

import React from "react";
import { useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';


import Theme from "./components/Theme";
import Home from "./pages/Home";
import MainNavbar from "./components/header/MainNavbar";
import LeftSideBar from "./components/LeftSideBar";
import Footer from "./components/header/Footer";
import Button from "./pages/Button";
import Form from "./pages/Form";
import Table from "./pages/Table";
import Card from "./pages/Card";
import Tabs from "./pages/Tabs";
import Accordion from "./pages/Accordion";
import Modal from "./pages/Modal";
import Alert from "./pages/Alert";
import ProgressBar from "./pages/ProgressBar";
import Tooltip from "./pages/Tooltip";
import FileUpload from "./pages/FileUpload";
import DropDown from "./pages/DropDown";
import LoginPage from "./pages/LoginPage";
import WYSIWYGEditor from "./pages/WysiwygEditor";
import Loader from "./pages/Loader";
import ImageCropper from "./pages/ImageCropper";
import Badge from "./pages/Badge";
import TimeLine from "./pages/TimeLine";
import Calendar from "./pages/Calendar";
import CountDown from "./pages/CountDown";
import Ribbon from "./pages/Ribbon";
import StickyElement from "./pages/StickyElement";
import GuidedTour from "./pages/GuidedTour";
import Reports from "./pages/Reports";
import Profile from "./components/Profile";
import PersonalProfile from "./components/PersonalProfile";

import{
  BrowserRouter,
  Routes,
  Route
} from 'react-router-dom';

const App = () => {
  const [isOpen, setIsOpen] = useState(true);

  return (
      <div className="full-container">
        <MainNavbar />
        {/* <Theme /> */}
        <LeftSideBar isOpen={isOpen} setIsOpen={setIsOpen} />
        <div className={`main-content ${isOpen ? "shift-right" : "full-width"}`}>
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/Button' element={<Button />} />
            <Route path='/Form' element={<Form />} /> 
            <Route path='/Table' element={<Table />} /> 
            <Route path='/Card' element={<Card />} /> 
            <Route path='/Tabs' element={<Tabs />} /> 
            <Route path='/Accordion' element={<Accordion />} /> 
            <Route path='/Modal' element={<Modal />} /> 
            <Route path='/Alert' element={<Alert />} /> 
            <Route path='/ProgressBar' element={<ProgressBar />} /> 
            <Route path='/Tooltip' element={<Tooltip />} /> 
            <Route path='/FileUpload' element={<FileUpload />} /> 
            <Route path='/DropDown' element={<DropDown />} /> 
            <Route path='/LoginPage' element={<LoginPage />} /> 
            <Route path='/WysiwygEditor' element={<WYSIWYGEditor />} /> 
            <Route path='/Loader' element={<Loader />} /> 
            <Route path='/ImageCropper' element={<ImageCropper />} /> 
            <Route path='/Badge' element={<Badge />} /> 
            <Route path='/TimeLine' element={<TimeLine />} /> 
            <Route path='/Calendar' element={<Calendar />} /> 
            <Route path='/CountDown' element={<CountDown />} /> 
            <Route path='/Ribbon' element={<Ribbon />} /> 
            <Route path='/StickyElement' element={<StickyElement />} /> 
            <Route path='/GuidedTour' element={<GuidedTour />} /> 
            <Route path='/Reports' element={<Reports />} /> 
            <Route path='/profile' element={<Profile />} /> 
            <Route path='/personalprofile' element={<PersonalProfile />} /> 
          </Routes>
        </div>
        <Footer />
      </div>
  );
};

export default App;
